import React from 'react'
import Lottie from 'react-lottie';
import * as animationData from '../success.json';
const BuyNowAnimation = () => {
    const defaultOptions = {
        loop: true,
        autoplay: true,
        animationData: animationData,
        rendererSettings: {
            preserveAspectRatio: "xMidYMid slice"
        }
    };
    return (
        <>
        <div className='mb-3'>
            <Lottie
                options={defaultOptions}
                height={50}
                width={50}
            />

        </div>
        </>
    )
}

export default BuyNowAnimation